import React, { Component } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import PicFSUpload from '../../../Common/picFSUpload';
import { httpPost } from '../../../Util/http';
import { addAlert } from '../../../MsgNotify/msgNotifyActions';

class Nearmiss extends Component {
    constructor(props) {
        super(props);
        this.state = {
            description: undefined,
            nearmissImage: null,
            touched: false,
            submitting: false,
        }
    }
    render() {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    backgroundColor: 'white',
                    height: 'auto',
                    width: 850,
                    padding: 20,
                    alignContent: 'center',
                    flexWrap: 'wrap',
                    position: 'relative',
                    alignItems: 'center',
                }}>
                <div style={{ width: '49%' }}>
                    <textarea
                        cols="30"
                        rows="10"
                        onClick={() => {
                            if (!this.state.touched) {
                                this.setState({ description: '' })
                            }
                        }}
                        onChange={(e) => this.setState({ description: e.target.value, touched: true })}
                        style={[styles.textarea, this.state.description ? {} : { color: 'grey' }]}
                        defaultValue="Her kan du registrere en Nærved-hændelse eller blot dele et godt råd med dine kollegaer.&#13;&#10;--&#13;&#10;Hvad skete der?&#13;&#10;Hvad kan der gøres for at det ikke sker igen?&#13;&#10;Har du et generelt råd i denne situation?"
                        value={this.state.description}
                    >
                    </textarea>
                    <button
                        style={{ width: '100%', marginTop: 10 }}
                        onClick={() => {
                            this.setState({ submitting: true })
                            const url = process.env.REACT_APP_workplaceAssessmentEndpoint + "api/nearmiss"
                            httpPost(url, {
                                description: this.state.description,
                                image: this.state.nearmissImage ? this.state.nearmissImage.substr(23) : null,
                                workplace: {
                                    workplaceId: this.props.workplace.id,
                                    workplaceName: this.props.workplace.name,
                                    projectNumber: this.props.workplace.project.number,
                                    projectName: this.props.workplace.project.name,
                                    client: this.props.workplace.client.name,
                                    contact: this.props.workplace.client.contact.name,
                                    departmentName: this.props.departmentName
                                }
                            })
                                .then(() => {
                                    setTimeout(() => this.setState({ submitting: 'done' }), 2000)
                                })
                                .then(() => {
                                    setTimeout(() => this.props.finito(), 6000)
                                })
                                .catch(() => {
                                    this.props.dispatch(addAlert('Kunne ikke afsende nærved-hændelse'))
                                    this.setState({ submitting: 'false' })
                                })
                        }
                        }
                        className="btn btn-primary">
                        {this.state.submitting === true ?

                            <i
                                className={"fa fa-spinner fa-spin"}
                                aria-hidden="true"
                            ></i>
                            :
                            this.state.submitting === 'done'
                                ?
                                <div>
                                    Tak for dit input
                                       <i
                                        className={"fa fa-thumbs-o-up"}
                                        aria-hidden="true"
                                        style={{ paddingLeft: 5 }}
                                    >
                                    </i>
                                </div>
                                :
                                "Send"

                        }


                    </button>
                </div>
                <div style={{ width: '2%' }}>
                    {/*divider*/}
                </div>
                <div style={{
                    width: '49%', '-webkit-appearance': 'none',
                    display: 'block',
                    border: 'none',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
                }}>
                    {this.state.nearmissImage ?
                        <div
                            onClick={() => { }}
                            style={styles.cardContainer}
                        >
                            <div
                                style={[styles.imgContainer,
                                { 'backgroundImage': 'url(' + this.state.nearmissImage + ')' }]}>
                            </div>
                        </div>
                        :
                        <PicFSUpload
                            className="waves-btn"
                            style={styles.uploadBtn}
                            onFilesSelected={files => {
                                var reader = new FileReader();
                                reader.onload = (function () {
                                    return function (e) {
                                        this.setState({
                                            nearmissImage: e.target.result
                                        })

                                    };
                                })(files[0]).bind(this);

                                // Read in the image file as a data URL.
                                reader.readAsDataURL(files[0]);
                            }}
                            multiple={false}>
                            <div>
                                <i
                                    className="fa fa-camera fa-2x"
                                    aria-hidden="true"
                                >
                                </i>
                                <div
                                    style={{ 'marginTop': '5px' }}>
                                    Tilføj billede
                                </div>
                            </div>
                        </PicFSUpload>
                    }
                </div>
            </div>
        );
    }
}

var styles = {
    textarea: {
        '-webkit-appearance': 'none',
        display: 'block',
        border: 'none',
        boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
        height: 'auto',
        resize: 'none',
        borderRadius: '2px',
        paddingLeft: '5px',
        width: '100%',
        heigth: '100%',
        marginBottom: 10
    },
    uploadBtn: {
        textAlign: 'center',
        padding: '0px',
        backgroundColor: '#fff',
        borderRadius: '2px',
        WebkitMaskImage: 'initial',
    },
    cardContainer: {
        height: '258px',
        width: '100%',
        paddingLeft: 20,
    },
    cardBody: {
        width: '100%',
        padding: '0px 12px'
    },
    innerContainer: {
        width: '100%',
        height: '100%',
        borderRadius: '2px',
        backgroundColor: '#fff',
        boxShadow: '0 0px 1px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)'
    },
    imgContainer: {
        maxWidth: '100%',
        maxHeight: '100%',
        height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
        borderTopRightRadius: '2px',
        borderTopLeftRadius: '2px'
    },
}

const selectProps = state => {
    return {
        ...state.workplaceOverviewReducer,
        ...state.kanbanReducer
    };
}

export default connect(selectProps)(Radium(Nearmiss));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Assessment/index.jsx